import angular from 'angular';

export const NotificacoesListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('meurh_notificacoes', {
            url: '/notificacoes?tab',
            template: require('html-loader!./index/notificacoes.index.html'),
            controller: 'NotificacoesIndexController',
            controllerAs: 'ntcoes_cntrllr',
        });
    }
];
